import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({
  providedIn: 'root'
})
export class PwaService {
  promptEvent;
  constructor(private updates: SwUpdate) { 
    updates.available.subscribe(event=>{
      updates.activateUpdate().then(()=> document.location.reload())
    })
    
    window.addEventListener('beforeinstallprompt', (event:any) => {
      this.promptEvent = event;
    });
  }
}
